import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Domain\Blog\Http\Controllers\Admin\MediaController::store
* @see app/Domain/Blog/Http/Controllers/Admin/MediaController.php:23
* @route '//org.launchstation.app/blog/media/{kind}/{id}'
*/
export const store = (args: { kind: string | number, id: string | number } | [kind: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//org.launchstation.app/blog/media/{kind}/{id}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\MediaController::store
* @see app/Domain/Blog/Http/Controllers/Admin/MediaController.php:23
* @route '//org.launchstation.app/blog/media/{kind}/{id}'
*/
store.url = (args: { kind: string | number, id: string | number } | [kind: string | number, id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            kind: args[0],
            id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        kind: args.kind,
        id: args.id,
    }

    return store.definition.url
            .replace('{kind}', parsedArgs.kind.toString())
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\MediaController::store
* @see app/Domain/Blog/Http/Controllers/Admin/MediaController.php:23
* @route '//org.launchstation.app/blog/media/{kind}/{id}'
*/
store.post = (args: { kind: string | number, id: string | number } | [kind: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\MediaController::store
* @see app/Domain/Blog/Http/Controllers/Admin/MediaController.php:23
* @route '//org.launchstation.app/blog/media/{kind}/{id}'
*/
const storeForm = (args: { kind: string | number, id: string | number } | [kind: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\MediaController::store
* @see app/Domain/Blog/Http/Controllers/Admin/MediaController.php:23
* @route '//org.launchstation.app/blog/media/{kind}/{id}'
*/
storeForm.post = (args: { kind: string | number, id: string | number } | [kind: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\MediaController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/MediaController.php:36
* @route '//org.launchstation.app/blog/media/{kind}/{id}'
*/
export const destroy = (args: { kind: string | number, id: string | number } | [kind: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//org.launchstation.app/blog/media/{kind}/{id}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\MediaController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/MediaController.php:36
* @route '//org.launchstation.app/blog/media/{kind}/{id}'
*/
destroy.url = (args: { kind: string | number, id: string | number } | [kind: string | number, id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            kind: args[0],
            id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        kind: args.kind,
        id: args.id,
    }

    return destroy.definition.url
            .replace('{kind}', parsedArgs.kind.toString())
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\MediaController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/MediaController.php:36
* @route '//org.launchstation.app/blog/media/{kind}/{id}'
*/
destroy.delete = (args: { kind: string | number, id: string | number } | [kind: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\MediaController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/MediaController.php:36
* @route '//org.launchstation.app/blog/media/{kind}/{id}'
*/
const destroyForm = (args: { kind: string | number, id: string | number } | [kind: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Blog\Http\Controllers\Admin\MediaController::destroy
* @see app/Domain/Blog/Http/Controllers/Admin/MediaController.php:36
* @route '//org.launchstation.app/blog/media/{kind}/{id}'
*/
destroyForm.delete = (args: { kind: string | number, id: string | number } | [kind: string | number, id: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const media = {
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
}

export default media